import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { MarketList, MarketRow, MarketSelect } from '@market/react';
import CDP_EVENT_NAMES from 'constants/cdp_events';
import { ISSUER_INSTALLMENTS_TERMS } from 'constants/financing';
import { useTranslation } from 'react-i18next';
import { useOrderDetails } from 'components/context/order_details';
import { trackCdp } from 'utilities/tracking';
import { getCountryCode } from 'utilities/locales';

const IssuerInstallmentSelect = ({
  issuerInstallmentsTerm,
  setIssuerInstallmentsTerm,
}) => {
  const { t } = useTranslation();
  const { trackingData } = useOrderDetails();
  const storeCode = getCountryCode().toUpperCase();

  useEffect(() => {
    trackCdp({
      name: CDP_EVENT_NAMES.CHECKOUT.PAYMENT.VIEW_ISSUER_INSTALLMENT_OPTIONS,
      params: {
        feature: 'shop',
        ...trackingData,
      },
    });
  }, []);

  return (
    <Grid container mb={4} data-testid="issuer-installment-select-component">
      <Grid item xs={12}>
        <Box component="h3" mb={2}>
          {t('checkout.payment.issuerInstallmentsHeader')}
        </Box>
        <MarketSelect
          value={
            issuerInstallmentsTerm ?? ISSUER_INSTALLMENTS_TERMS[storeCode][0]
          }
          onMarketSelectValueDidChange={(event) =>
            setIssuerInstallmentsTerm(event.detail.value)
          }
          style={{ height: '48px' /* match height of CC input field */ }}
        >
          <MarketList slot="list">
            {ISSUER_INSTALLMENTS_TERMS[storeCode].map((term) => (
              <MarketRow key={term} value={term}>
                <label slot="label">
                  {term === '1'
                    ? t('checkout.issuer_installments_options.single_payment')
                    : t(
                        'checkout.issuer_installments_options.multiple_payments',
                        { count: term },
                      )}
                </label>
              </MarketRow>
            ))}
          </MarketList>
        </MarketSelect>
      </Grid>
    </Grid>
  );
};

export default IssuerInstallmentSelect;
